var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.src + '',"contain":""},on:{"click":function($event){return _vm.$emit('imageClicked', { item: _vm.item })}}})}
var staticRenderFns = []

export { render, staticRenderFns }